export const schoolRoutes = [
  {
    path: '/school/study',
    name: 'SchoolStudy',
    component: () => import(/* webpackChunkName: "school" */'@/views/school/study/Study.vue'),
    meta: {
      title: '學習違禁品知識'
    }
  },
  {
    path: '/school/exam',
    name: 'SchoolExam',
    component: () => import(/* webpackChunkName: "school" */'@/views/school/exam/Exam.vue'),
    meta: {
      title: '違禁品測試'
    }
  },
]
